import actionTypes from 'Redux/constants';

const initialState = {
  designAuditCounts: {
    reviews_this_month: 0,
    reviews_in_progress: 0,
    reviews_completed: 0,
    customer_name: '',
  },
  designAuditHistory: {
    count: 0,
    next: null,
    previous: null,
    results: [],
  },
};

const designAuditReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_DESIGN_AUDIT_COUNTS:
      return {
        ...state,
        designAuditCounts: action.payload,
      };

    case actionTypes.GET_DESIGN_AUDIT_HISTORY:
      return {
        ...state,
        designAuditHistory: action.payload,
      };

    default:
      return state;
  }
};

export default designAuditReducer;
